import z from "zod";

const flag = z
  .string()
  .optional()
  .transform((value) => undefined !== value && "false" !== value);

export const jobEditorDataSchema = z.object({
  projectId: z.coerce.number().int().positive(),
  jobId: z
    .string()
    .optional()
    .transform((value) => {
      const id = Number(value);

      return value && Number.isInteger(id) && id > 0 ? id : null;
    }),
  contained: flag,
  open: flag,
});

export type JobEditorDataProps = z.infer<typeof jobEditorDataSchema>;
